<template>
<div id="app">
	<header-top></header-top>
	<!-- <router-view  /> -->
	<transition name="fade">
		<router-view  />
	</transition>
	
	<!-- 通用底部 -->
	<footer class="footer">
		<div class="item">
			<span>主办单位：学生工作与教师发展</span>
			<span>地址：北京市海淀区复兴路75号</span>
			
		</div>
		<div class="item">
			<span>技术支持：国开在线教育科技有限公司</span>
			<span>邮编：100039 </span>
		</div>
	</footer>
</div>
</template>

<script>
import headerTop from'./components/header/index.vue'
export default {
	name: 'App',
	components:{
		'header-top':headerTop,
	},
	data(){
		return {
			bannerImg:null
		}
	},
	created() {
		//this.getFriendLink()
		//获取浏览器宽高
		// this.$store.commit('changeWindow',{winW:window.innerWidth,winH:window.innerHeight})
		// window.onresize = () => {
		// 	this.$store.commit('changeWindow',{winW:window.innerWidth,winH:window.innerHeight})
		// 	var isMobile = this.$common.isMobile()
		// 	this.$store.commit('changeIsMobile',isMobile)
		// },
		var uuid = localStorage.getItem("uuid")?localStorage.getItem("uuid"):this.$common.randomString(32)
		this.$store.commit('changeUuid',uuid)
		if(!localStorage.getItem("uuid")){
			localStorage.setItem("uuid",uuid)
		}
	},
	
	methods:{
		//获取友情链接
		// getFriendLink(){
		// 	this.$axios({
		// 		url:'/index.php?s=common&c=api&m=getOutsideChain',
		// 		success:(res)=>{
		// 			this.$store.commit('changeFriendLink',res.data)
		// 		}
		// 	})
		// },
	}
}
</script>

<style lang="less">
@import '~@/assets/css/reset.less';
@import '~@/assets/css/common.less';
</style>



// WEBPACK FOOTER //
// src/App.vue